import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { CustomerForm } from "@/features/dashboard/clientes/components/CustomerForm";

export const Route = createFileRoute("/_private/dashboard/_base/clientes/editar/$id/modal")({
  component: RouteComponent
});

function RouteComponent() {
  const { id } = Route.useParams();

  return (
    <BaseEditCreateModal title="Editar Cliente" from="/dashboard/clientes/editar/$id">
      <CustomerForm id={id} />
    </BaseEditCreateModal>
  );
}
